import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { PER_PAGE } from '@/plugins/vuex-async-pagginate';

class WorkTimeServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getAll(time_condition_id, params = {}) {
    if (time_condition_id !== null) {
      return this.http.get(`/${time_condition_id}/worktimes`, {
        params: { [PER_PAGE]: 500, ...params }
      });
    }
  }

  createItem(time_condition_id, params) {
    return this.http.post(`/${time_condition_id}/worktimes`, params);
  }

  removeAll(time_condition_id) {
    return this.http.delete(`/${time_condition_id}/worktimes`);
  }
}

export const WorkTimeService = new WorkTimeServiceClass({
  api_version: 2,
  resource: 'pbx/time-conditions'
});
